import {service} from '../common/request.js';
 
export function login(data) {
  return service({
		url: '/app/account/login',
		method: 'POST',
		data
	})
}

export function loginOut(data) {
	return service({
		url: '/app/account/logout',
		method: 'POST',
		data
	})
}

export function getUserInfo(id) {
	return service({
		url: `/app/student/${id}`,
		method: 'GET'
	})
}

export function getLastApp(data) {
  return service({
		url: '/app/version/last',
		method: 'POST',
		data
	})
}

export function getSwiperList(data) {
	return service({
		url: '/app/carousel/list',
		method: 'GET',
		data
	})
}

export function getClassList(data) {
	return service({
		url: '/app/phase-student/list',
		method: 'GET',
		data
	})
}

export function getExamList(data) {
	return service({
		url: '/app/paper-student/list',
		method: 'GET',
		data
	})
}